import DiscussionUserEmpty from './DiscussionUserEmpty';

export default DiscussionUserEmpty;
